import { render, staticRenderFns } from "./SliderInput.vue?vue&type=template&id=c3536f86"
import script from "./SliderInput.vue?vue&type=script&lang=js"
export * from "./SliderInput.vue?vue&type=script&lang=js"
import style0 from "./SliderInput.vue?vue&type=style&index=0&id=c3536f86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports